import React from 'react';
const AppContext = React.createContext();

/* Prevent circular dependencies - webpack messes up the context api otherwise */
export default AppContext;
